import { createReducer, on } from '@ngrx/store';
import * as ApiCacheActions from './api-cache.actions';

export interface ApiCacheState {
  [key: string]: ApiCacheActions.ApiCacheEntry;
}

export interface ApiCacheRootState {
  cache: ApiCacheState;
}

export const initialState: ApiCacheRootState = {
  cache: {}
};

export const apiCacheReducer = createReducer(
  initialState,

  on(ApiCacheActions.setApiCacheData, (state, { key, data }) => ({
    ...state,
    cache: {
      ...state.cache,
      [key]: data
    }
  })),

  on(ApiCacheActions.clearApiCacheData, (state, { key }) => {
    const newCache = { ...state.cache };
    delete newCache[key];
    return {
      ...state,
      cache: newCache
    };
  }),

  on(ApiCacheActions.clearAllApiCache, () => ({
    ...initialState
  })),

  on(ApiCacheActions.incrementRequestCount, (state, { key }) => {
    const entry = state.cache[key];
    if (!entry) {
      return state;
    }
    return {
      ...state,
      cache: {
        ...state.cache,
        [key]: {
          ...entry,
          requestCount: entry.requestCount + 1
        }
      }
    };
  })
);

